import React, { useState, createContext, useContext } from 'react';
type Language = 'en' | 'es';
interface Translations {
  [key: string]: any;
}
const translations: Record<Language, Translations> = {
  en: {
    urgency: 'Limited to 3 moves per day — Secure your spot at least 72 hours before your move!',
    nav: {
      packages: 'Packages',
      coverage: 'Coverage',
      howItWorks: 'How It Works',
      faq: 'FAQ',
      cta: 'Choose My Package'
    },
    hero: {
      title: 'MOVE RESCUED! BUY YOUR PACKAGE TODAY AND FORGET THE REGRETS.',
      subtitle: "At Move Fighters, we treat your move like a top-priority emergency. No deceptive contracts. No hidden fees. Just a fixed price and a team of 'Firefighter Movers' ready for action in Tampa.",
      cta: 'CHOOSE MY PACKAGE NOW'
    },
    problem: {
      title: "Tired of the 'Low Ballers'?",
      subtitle: "Other companies quote $90/hour to trap you, but then the 'fire' starts:",
      points: ['Stair charges.', 'Extra diesel and mileage charges.', 'Bed disassembly charges.', 'The clock ticks while they walk slow.'],
      conclusion: "In the end, your 'low cost' move ends up costing $1,500 or more.",
      extinguish: "At Move Fighters, we extinguish the scam. The price you see is the price you pay. We are specialists in 'residential rescues'."
    },
    packages: {
      title: 'SELECT YOUR RESCUE UNIT',
      subtitle: 'All inclusive: Truck, Pro Team, Assembly/Disassembly, TV Protection, Courtesy Boxes, and Zero Stress.',
      webExclusive: 'Web-exclusive pricing — these terms only apply when you buy through our website.',
      buyNow: 'BUY NOW',
      vsCompetitors: 'Vs. {price} with competitors',
      includes: 'Includes:',
      units: [{
        id: 'basic',
        name: 'THE STUDIO RESCUE',
        desc: '1 Room — The basic apartment or bachelor pad.',
        price: 600,
        checkoutUrl: 'https://www.movefighters.com/cart/46708023066814:1',
        competitorPrice: '$900',
        competitorCallout: 'Other companies will charge you $900+ after adding diesel and stairs.',
        estado: 'Guaranteed Price for Tampa (50-mile radius)',
        features: ['2 Firefighter Movers + Truck', 'Bed/frame, Sofa, TV stand & mirrors protection', '4 Professional Boxes + 1 Tape incl.', 'Protective blankets included', 'Diesel & Travel (Tampa 50mi)']
      }, {
        id: 'commander',
        name: 'THE COMMANDER',
        desc: '2 Rooms — The perfect rescue for small families. Living & Kitchen included.',
        price: 1050,
        checkoutUrl: 'https://www.movefighters.com/cart/46708086243518:1',
        competitorPrice: '$1,500',
        competitorCallout: 'Other companies will charge you $1,500+ when the clock starts running slow.',
        estado: 'Locked Price. No last-minute charges.',
        features: ['3 Firefighter Movers + Truck', 'Total furniture protection', '8 Professional Boxes + 2 Tapes incl.', 'Protective blankets included', 'No stair or long-walk charges', 'Diesel & Travel (Tampa 50mi)']
      }, {
        id: 'captain',
        name: 'THE CAPTAIN',
        desc: '3 Rooms — Heavy rescue. Covers 3 rooms, Living, Kitchen AND THE GARAGE.',
        price: 1399,
        checkoutUrl: 'https://www.movefighters.com/cart/46708058915006:1',
        competitorPrice: '$2,000',
        competitorCallout: "Other companies will charge you $2,000+ because they'll say it's 'too much load'.",
        estado: 'The total solution for family homes.',
        features: ["3 Elite Specialists + 26' Truck", 'Garage & Patio load included', '11 Professional Boxes + 3 Tapes incl.', 'Protective blankets included', 'No stair or long-walk charges', 'Diesel & Travel (Tampa 50mi)']
      }, {
        id: 'battalion',
        name: 'THE BATTALION PRO',
        desc: '4+ Rooms — Maximum Response Unit for large 4+ bedroom homes.',
        price: 1750,
        checkoutUrl: 'https://www.movefighters.com/cart/46708065796286:1',
        competitorPrice: '$2,600',
        competitorCallout: 'Other companies will charge you $2,600+ and send inexperienced workers.',
        estado: 'Life insurance for your big move.',
        features: ['4 Firefighter Movers + XL Truck', 'Logistics Priority', '15 Professional Boxes + 4 Tapes incl.', 'Protective blankets included', 'No stair or long-walk charges', 'Diesel & Travel (Tampa 50mi)']
      }]
    },
    coverage: {
      title: 'OPERATION TAMPA',
      subtitle: 'Coverage Area',
      description: "Are you on the map? Your price is guaranteed. If your move is outside this radius, call us for a 'Long Distance Rescue'.",
      radius: '50-Mile Rescue Radius'
    },
    howItWorks: {
      title: 'MOVE IN 1 CLICK',
      steps: [{
        title: 'Choose your package',
        desc: 'No infinite inventories. If it fits in the number of rooms, we take it.'
      }, {
        title: 'Pay & Book',
        desc: 'Enter origin, destination and select your date (Min 72 hours ahead).'
      }, {
        title: 'Confirmation Call',
        desc: 'A specialist calls you immediately to verify specific details and access.'
      }, {
        title: 'Rescue Day',
        desc: 'We arrive, load, unload, and you just relax.'
      }]
    },
    trust: {
      title: 'SAFETY & CERTAINTY',
      factors: [{
        title: 'Trained Personnel',
        desc: "We don't send day laborers. We send uniformed and trained 'Fighters'."
      }, {
        title: 'Iron Protection',
        desc: 'Your furniture is wrapped in protective blankets and plastic like treasures.'
      }, {
        title: 'Emergency Punctuality',
        desc: 'If we say 8:00 AM, we are there at 7:55 AM.'
      }, {
        title: 'No-Extra Guarantee',
        desc: "If you bought it here, we won't ask for a single dollar more on moving day."
      }]
    },
    gallery: {
      title: 'FIGHTERS IN ACTION',
      subtitle: 'Real moves. Real families. Real results.',
      captions: ['Professional packing with protective blankets', 'Our branded fleet — ready to deploy', 'Happy families, successful rescues', 'The Move Fighters handshake of trust', 'Full house rescue — furniture protection guaranteed']
    },
    stats: {
      title: 'MOVE FIGHTERS BY THE NUMBERS',
      subtitle: 'Real results from real rescues across Tampa Bay',
      items: [{
        value: 10500,
        suffix: '+',
        label: 'Moves Completed',
        desc: 'Successful residential rescues'
      }, {
        value: 68,
        suffix: '',
        label: 'Units in Fleet',
        desc: 'Ready to deploy any day'
      }, {
        value: 35,
        suffix: '+',
        label: 'Pro Movers',
        desc: 'Trained & uniformed Fighters'
      }, {
        value: 99,
        suffix: '%',
        label: 'Satisfaction Rate',
        desc: 'Based on customer surveys'
      }, {
        value: 50,
        suffix: 'mi',
        label: 'Coverage Radius',
        desc: 'Tampa metro & beyond'
      }, {
        value: 4.9,
        suffix: '/5',
        label: 'Star Rating',
        desc: 'Google & Yelp average'
      }],
      bars: [{
        label: 'On-Time Arrival',
        value: 98
      }, {
        label: 'Customer Satisfaction',
        value: 99
      }, {
        label: 'Zero Damage Rate',
        value: 97
      }, {
        label: 'Same-Week Availability',
        value: 85
      }]
    },
    testimonials: {
      title: 'WHAT OUR RESCUED CUSTOMERS SAY',
      subtitle: 'Real reviews from real Tampa Bay families',
      reviews: [{
        name: 'Maria G.',
        location: 'Brandon → Tampa',
        rating: 5,
        text: 'Incredible service! They arrived early, wrapped everything perfectly, and finished in half the time I expected. The fixed price was exactly what I paid — no surprises. Best movers in Tampa!',
        date: 'March 2026'
      }, {
        name: 'James T.',
        location: 'Clearwater → Wesley Chapel',
        rating: 5,
        text: 'After getting burned by hourly movers twice, I found Move Fighters. The Commander package was perfect for my 2-bedroom apartment. Professional, fast, and the price was locked in.',
        date: 'February 2026'
      }, {
        name: 'Sofia R.',
        location: 'Riverview → Lakeland',
        rating: 5,
        text: 'I was nervous about my piano and antique furniture. These guys treated everything like it was their own. Not a single scratch. The protective blankets they use are top quality.',
        date: 'January 2026'
      }, {
        name: 'David K.',
        location: 'St. Petersburg → Sarasota',
        rating: 5,
        text: 'The Battalion package handled our entire 4-bedroom house. 4 guys showed up at 7:55 AM sharp. Everything was done by 2 PM. Worth every penny compared to the $2,500 quotes I got elsewhere.',
        date: 'March 2026'
      }, {
        name: 'Ana L.',
        location: 'Temple Terrace → Valrico',
        rating: 5,
        text: 'Hablaban español lo cual fue genial para mi abuela. Super profesionales, rápidos y el precio fijo me dio mucha tranquilidad. 100% recomendados!',
        date: 'February 2026'
      }, {
        name: 'Robert M.',
        location: 'Lutz → New Tampa',
        rating: 5,
        text: 'Third time using Move Fighters. They never disappoint. The online booking was easy, the team was friendly, and they even assembled my bed at the new place. Five stars every time.',
        date: 'April 2026'
      }]
    },
    booking: {
      title: 'REQUEST RESCUE',
      origin: 'Origin (Full Address)',
      destination: 'Destination (Full Address)',
      date: 'Move Date',
      stairs: 'Floor/Stairs? (Info only, included in price)',
      notes: "Special Notes (e.g., 'I have a piano')",
      submit: 'CONFIRM RESCUE',
      options: {
        ground: 'Ground Floor',
        elevator: 'Elevator',
        stairs1: '1 Flight of Stairs',
        stairs2: '2+ Flights of Stairs'
      }
    },
    order: {
      yourPackage: 'Your Package',
      totalFixed: 'Fixed total — no hidden fees',
      stepDetails: 'Move Details',
      stepContact: 'Your Info',
      stepSummary: 'Review',
      moveDetails: 'Move Details',
      origin: 'Pickup Address (Origin)',
      originPlaceholder: '123 Main St, Tampa, FL 33602',
      originAccess: 'Origin — Floor / Access',
      destination: 'Delivery Address (Destination)',
      destPlaceholder: '456 Oak Ave, Clearwater, FL 33755',
      destAccess: 'Destination — Floor / Access',
      moveDate: 'Move Date',
      minDateNote: 'Minimum 72 hours in advance required. Need a same-day move? Call us at (813) 476-8935.',
      contactInfo: 'Contact Information',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone Number',
      notes: 'Special Notes',
      notesPlaceholder: "e.g., 'I have a piano', 'Careful with hardwood floors'",
      stairsOptions: {
        ground: 'Ground Floor',
        elevator: 'Elevator',
        stairs1: '1 Flight of Stairs',
        stairs2: '2 Flights of Stairs',
        stairs3: '3+ Flights of Stairs'
      },
      errors: {
        required: 'This field is required.',
        outsideArea: 'This address must be within the Tampa metro area (50-mile radius). Please include the city name or FL zip code.',
        minDate: 'Move date must be at least 72 hours from now.',
        invalidEmail: 'Please enter a valid email address.',
        invalidPhone: 'Please enter a valid phone number (min 10 digits).'
      },
      areaQualifies: 'Area qualifies — within Tampa 50-mile service zone',
      next: 'Continue',
      back: 'Back',
      reviewOrder: 'Review Order',
      orderSummary: 'Order Summary',
      fromLabel: 'From',
      toLabel: 'To',
      dateLabel: 'Move Date',
      allIncluded: 'Truck, team, blankets, boxes, diesel — all included.',
      emailNotice: 'After confirming, your order details will be sent to our team and you will receive a confirmation email.',
      confirmAndPay: 'RESCUE MY HOME',
      redirectingTitle: 'REDIRECTING TO SECURE CHECKOUT...',
      redirectingMessage: 'Your move details have been saved. Taking you to complete your payment now.',
      orderRef: 'Order Reference',
      close: 'Back to Home'
    },
    faq: {
      title: 'FREQUENTLY ASKED QUESTIONS',
      questions: [{
        q: 'Why is the price so low compared to others?',
        a: "Because we eliminated the fancy office, the phone salespeople, and the time waste. We're an automated, efficient operation that passes the savings directly to you."
      }, {
        q: 'What if I have stairs or live on a 3rd floor?',
        a: "We don't care. Other companies punish you for living in an apartment with stairs. We are 'Fighters' — we're trained for that. The price is the same."
      }, {
        q: 'What if the truck arrives and there are more boxes than I said?',
        a: 'Our packages are based on house size (Rooms). If you chose the right package for your 2-bedroom home, we load everything that belongs in that house. No drama.'
      }, {
        q: "What if I don't have an exact date yet?",
        a: "You can buy your package today to secure the frozen price and send us a 'Pending Date' ticket. Once you have it, notify us at least 72 hours in advance to schedule."
      }, {
        q: 'Can I change the date after purchasing?',
        a: 'Yes, as long as there is availability and you notify us more than 72 hours in advance. We do not charge a penalty for the first change.'
      }, {
        q: 'Do you really include diesel and stairs?',
        a: 'YES. The Move Fighters concept is to eliminate the fine print. The price you pay on this website is the TOTAL.'
      }]
    },
    footer: {
      tagline: 'Rescuing Your Home in Tampa.',
      licensed: 'Licensed & Insured — FL Mover Registration Active',
      help: 'Need immediate help?',
      callNow: 'Call Now',
      rights: 'All rights reserved.',
      services: {
        title: 'Our Services',
        items: ['Residential Moving', 'Apartment Moving', 'Furniture Assembly', 'TV & Electronics Protection', 'Packing & Unpacking', 'Same-Week Scheduling']
      },
      company: {
        title: 'Company',
        items: ['About Move Fighters', 'Our Fleet', 'Coverage Area', 'Careers', 'Contact Us']
      },
      legal: {
        title: 'Legal',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy',
        cancellation: 'Cancellation Policy',
        insurance: 'Insurance & Liability'
      },
      contact: {
        title: 'Contact',
        phone: '(813) 476-8935',
        email: 'info@movefighters.com',
        hours: 'Mon–Sat: 7:00 AM – 8:00 PM',
        hoursSun: 'Sunday: 8:00 AM – 5:00 PM',
        address: 'Tampa, FL — Serving 50-mile radius'
      },
      newsletter: {
        title: 'Get Moving Tips & Deals',
        placeholder: 'Enter your email',
        button: 'Subscribe',
        note: 'No spam. Unsubscribe anytime.'
      },
      badges: ['Fixed Pricing', 'No Hidden Fees', 'Licensed & Insured', 'Tampa Local']
    }
  },
  es: {
    urgency: 'Limitado a 3 mudanzas por día — ¡Reserva tu cupo al menos 72 horas antes de tu mudanza!',
    nav: {
      packages: 'Paquetes',
      coverage: 'Cobertura',
      howItWorks: 'Cómo Funciona',
      faq: 'Preguntas',
      cta: 'Elegir Mi Paquete'
    },
    hero: {
      title: '¡MUDANZA RESCATADA! COMPRA TU PAQUETE HOY Y OLVÍDATE DE LAMENTOS.',
      subtitle: "En Move Fighters tratamos tu mudanza como una emergencia de máxima prioridad. Sin contratos engañosos. Sin cargos ocultos. Solo un precio fijo y un equipo de 'Bomberos Mudadores' listos para la acción en Tampa.",
      cta: 'ELEGIR MI PAQUETE AHORA'
    },
    problem: {
      title: "¿Cansado de los 'Low Ballers'?",
      subtitle: "Otras empresas te dicen $90/hora para atraparte, pero luego el 'fuego' comienza:",
      points: ['Cargos por escaleras.', 'Cargo por diesel y millaje extra.', 'Cargo por desarmar la cama.', 'El reloj corre y ellos caminan lento.'],
      conclusion: "Al final, tu mudanza de 'bajo costo' termina costando $1,500 o más.",
      extinguish: "En Move Fighters, extinguimos el engaño. El precio que ves es el precio que pagas. Somos especialistas en 'rescates residenciales'."
    },
    packages: {
      title: 'SELECCIONA TU UNIDAD DE RESCATE',
      subtitle: 'Todo incluido: Camión, Equipo Pro, Desarmado/Armado, Protección de TV, Cajas de Cortesía y Cero Estrés.',
      webExclusive: 'Precios exclusivos web — estos términos solo aplican al comprar a través de nuestra página.',
      buyNow: 'COMPRAR AHORA',
      vsCompetitors: 'Vs. {price} en competencia',
      includes: 'Incluye:',
      units: [{
        id: 'basic',
        name: 'THE STUDIO RESCUE',
        desc: '1 Habitación — El apartamento básico o el cuarto de soltero.',
        price: 600,
        checkoutUrl: 'https://www.movefighters.com/cart/46708023066814:1',
        competitorPrice: '$900',
        competitorCallout: 'Otras empresas te cobrarán $900+ tras sumar el diesel y las escaleras.',
        estado: 'Precio Garantizado para Tampa (Radio 50 millas)',
        features: ['2 Bomberos Mudadores + Camión', 'Protección de cama/frame, sofá, mueble de TV y espejos', '4 Cajas Profesionales + 1 Tape incl.', 'Mantas protectoras incluidas', 'Diesel y Viaje (Tampa 50m)']
      }, {
        id: 'commander',
        name: 'THE COMMANDER',
        desc: '2 Habitaciones — El rescate perfecto para familias pequeñas. Living y Cocina incluidos.',
        price: 1050,
        checkoutUrl: 'https://www.movefighters.com/cart/46708086243518:1',
        competitorPrice: '$1,500',
        competitorCallout: 'Otras empresas te cobrarán $1,500+ cuando el reloj empiece a correr lento.',
        estado: 'Precio Cerrado. Sin cargos de última hora.',
        features: ['3 Bomberos Mudadores + Camión', 'Protección total de mobiliario', '8 Cajas Profesionales + 2 Tapes incl.', 'Mantas protectoras incluidas', 'Sin cargo por escaleras o tramos largos', 'Diesel y Viaje (Tampa 50m)']
      }, {
        id: 'captain',
        name: 'THE CAPTAIN',
        desc: '3 Habitaciones — Rescate pesado. Cubre 3 habitaciones, Living, Cocina Y EL GARAGE.',
        price: 1399,
        checkoutUrl: 'https://www.movefighters.com/cart/46708058915006:1',
        competitorPrice: '$2,000',
        competitorCallout: 'Otras empresas te cobrarán $2,000+ porque te dirán que "es mucha carga".',
        estado: 'La solución total para casas familiares.',
        features: ["3 Especialistas de Élite + Camión de 26'", 'Carga de Garage y Patio incluida', '11 Cajas Profesionales + 3 Tapes incl.', 'Mantas protectoras incluidas', 'Sin cargo por escaleras o tramos largos', 'Diesel y Viaje (Tampa 50m)']
      }, {
        id: 'battalion',
        name: 'THE BATTALION PRO',
        desc: '4+ Habitaciones — La Unidad de Respuesta Máxima para casas grandes.',
        price: 1750,
        checkoutUrl: 'https://www.movefighters.com/cart/46708065796286:1',
        competitorPrice: '$2,600',
        competitorCallout: 'Otras empresas te cobrarán $2,600+ y te enviarán a gente sin experiencia.',
        estado: 'El seguro de vida para tu mudanza grande.',
        features: ['4 Bomberos Mudadores + Camión XL', 'Prioridad Logística', '15 Cajas Profesionales + 4 Tapes incl.', 'Mantas protectoras incluidas', 'Sin cargo por escaleras o tramos largos', 'Diesel y Viaje (Tampa 50m)']
      }]
    },
    coverage: {
      title: 'OPERACIÓN TAMPA',
      subtitle: 'Área de Cobertura',
      description: "¿Estás dentro del mapa? Tu precio está garantizado. Si tu mudanza es fuera de este radio, llámanos para el 'Rescate de Larga Distancia'.",
      radius: 'Radio de Rescate de 50 Millas'
    },
    howItWorks: {
      title: 'MUDANZA EN 1 CLIC',
      steps: [{
        title: 'Eliges tu paquete',
        desc: 'Sin inventarios infinitos. Si cabe en el número de habitaciones, nosotros lo llevamos.'
      }, {
        title: 'Pagas y Reservas',
        desc: 'Ingresas origen, destino y seleccionas tu fecha (Mínimo 72 horas de anticipación).'
      }, {
        title: 'Llamada de Confirmación',
        desc: 'Un especialista te llama de inmediato para verificar detalles específicos y accesos.'
      }, {
        title: 'Día del Rescate',
        desc: 'Llegamos, cargamos, descargamos y tú solo te relajas.'
      }]
    },
    trust: {
      title: 'SEGURIDAD Y CERTEZA',
      factors: [{
        title: 'Personal Entrenado',
        desc: "No enviamos jornaleros del día. Enviamos 'Fighters' uniformados y entrenados."
      }, {
        title: 'Protección de Hierro',
        desc: 'Tus muebles se envuelven en mantas protectoras y plástico como si fueran tesoros.'
      }, {
        title: 'Puntualidad de Emergencia',
        desc: 'Si decimos a las 8:00 AM, estamos ahí a las 7:55 AM.'
      }, {
        title: 'Garantía No-Extra',
        desc: 'Si lo compraste aquí, no te pediremos ni un dólar más el día de la mudanza.'
      }]
    },
    gallery: {
      title: 'FIGHTERS EN ACCIÓN',
      subtitle: 'Mudanzas reales. Familias reales. Resultados reales.',
      captions: ['Empaque profesional con mantas protectoras', 'Nuestra flota con marca — lista para desplegar', 'Familias felices, rescates exitosos', 'El apretón de manos de confianza Move Fighters', 'Rescate de casa completa — protección de muebles garantizada']
    },
    stats: {
      title: 'MOVE FIGHTERS EN NÚMEROS',
      subtitle: 'Resultados reales de rescates reales en Tampa Bay',
      items: [{
        value: 10500,
        suffix: '+',
        label: 'Mudanzas Completadas',
        desc: 'Rescates residenciales exitosos'
      }, {
        value: 68,
        suffix: '',
        label: 'Unidades en Flota',
        desc: 'Listos para desplegar cualquier día'
      }, {
        value: 35,
        suffix: '+',
        label: 'Mudanceros Pro',
        desc: 'Fighters entrenados y uniformados'
      }, {
        value: 99,
        suffix: '%',
        label: 'Tasa de Satisfacción',
        desc: 'Basado en encuestas de clientes'
      }, {
        value: 50,
        suffix: 'mi',
        label: 'Radio de Cobertura',
        desc: 'Tampa metro y alrededores'
      }, {
        value: 4.9,
        suffix: '/5',
        label: 'Calificación',
        desc: 'Promedio Google y Yelp'
      }],
      bars: [{
        label: 'Llegada a Tiempo',
        value: 98
      }, {
        label: 'Satisfacción del Cliente',
        value: 99
      }, {
        label: 'Tasa Cero Daños',
        value: 97
      }, {
        label: 'Disponibilidad Semanal',
        value: 85
      }]
    },
    testimonials: {
      title: 'LO QUE DICEN NUESTROS CLIENTES RESCATADOS',
      subtitle: 'Reseñas reales de familias de Tampa Bay',
      reviews: [{
        name: 'Maria G.',
        location: 'Brandon → Tampa',
        rating: 5,
        text: '¡Servicio increíble! Llegaron temprano, envolvieron todo perfectamente y terminaron en la mitad del tiempo que esperaba. El precio fijo fue exactamente lo que pagué — sin sorpresas. ¡Los mejores mudanceros de Tampa!',
        date: 'Marzo 2026'
      }, {
        name: 'James T.',
        location: 'Clearwater → Wesley Chapel',
        rating: 5,
        text: 'Después de ser estafado por mudanceros por hora dos veces, encontré Move Fighters. El paquete Commander fue perfecto para mi apartamento de 2 habitaciones. Profesionales, rápidos y el precio estaba fijo.',
        date: 'Febrero 2026'
      }, {
        name: 'Sofia R.',
        location: 'Riverview → Lakeland',
        rating: 5,
        text: 'Estaba nerviosa por mi piano y muebles antiguos. Estos chicos trataron todo como si fuera suyo. Ni un solo rasguño. Las mantas protectoras que usan son de primera calidad.',
        date: 'Enero 2026'
      }, {
        name: 'David K.',
        location: 'St. Petersburg → Sarasota',
        rating: 5,
        text: 'El paquete Battalion manejó toda nuestra casa de 4 habitaciones. 4 chicos llegaron a las 7:55 AM en punto. Todo terminó a las 2 PM. Vale cada centavo comparado con las cotizaciones de $2,500 que recibí en otros lugares.',
        date: 'Marzo 2026'
      }, {
        name: 'Ana L.',
        location: 'Temple Terrace → Valrico',
        rating: 5,
        text: 'Hablaban español lo cual fue genial para mi abuela. Super profesionales, rápidos y el precio fijo me dio mucha tranquilidad. 100% recomendados!',
        date: 'Febrero 2026'
      }, {
        name: 'Robert M.',
        location: 'Lutz → New Tampa',
        rating: 5,
        text: 'Tercera vez usando Move Fighters. Nunca decepcionan. La reserva en línea fue fácil, el equipo fue amable y hasta armaron mi cama en la nueva casa. Cinco estrellas siempre.',
        date: 'Abril 2026'
      }]
    },
    booking: {
      title: 'SOLICITAR RESCATE',
      origin: 'Origen (Dirección completa)',
      destination: 'Destino (Dirección completa)',
      date: 'Fecha de la Mudanza',
      stairs: '¿Piso/Escaleras? (Solo info, incluido en precio)',
      notes: "Notas especiales (ej. 'Tengo un piano')",
      submit: 'CONFIRMAR RESCATE',
      options: {
        ground: 'Planta Baja',
        elevator: 'Elevador',
        stairs1: '1 Piso por Escaleras',
        stairs2: '2+ Pisos por Escaleras'
      }
    },
    order: {
      yourPackage: 'Tu Paquete',
      totalFixed: 'Total fijo — sin cargos ocultos',
      stepDetails: 'Detalles',
      stepContact: 'Tu Info',
      stepSummary: 'Revisar',
      moveDetails: 'Detalles de la Mudanza',
      origin: 'Dirección de Recogida (Origen)',
      originPlaceholder: '123 Main St, Tampa, FL 33602',
      originAccess: 'Origen — Piso / Acceso',
      destination: 'Dirección de Entrega (Destino)',
      destPlaceholder: '456 Oak Ave, Clearwater, FL 33755',
      destAccess: 'Destino — Piso / Acceso',
      moveDate: 'Fecha de Mudanza',
      minDateNote: 'Se requiere un mínimo de 72 horas de anticipación. ¿Necesitas mudanza el mismo día? Llámanos al (813) 476-8935.',
      contactInfo: 'Información de Contacto',
      fullName: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Número de Teléfono',
      notes: 'Notas Especiales',
      notesPlaceholder: "ej., 'Tengo un piano', 'Cuidado con el suelo de madera'",
      stairsOptions: {
        ground: 'Planta Baja',
        elevator: 'Elevador',
        stairs1: '1 Piso por Escaleras',
        stairs2: '2 Pisos por Escaleras',
        stairs3: '3+ Pisos por Escaleras'
      },
      errors: {
        required: 'Este campo es obligatorio.',
        outsideArea: 'Esta dirección debe estar dentro del área metropolitana de Tampa (radio de 50 millas). Incluya el nombre de la ciudad o código postal de FL.',
        minDate: 'La fecha de mudanza debe ser al menos 72 horas a partir de ahora.',
        invalidEmail: 'Por favor ingrese un correo electrónico válido.',
        invalidPhone: 'Por favor ingrese un número de teléfono válido (mín 10 dígitos).'
      },
      areaQualifies: 'Área califica — dentro de la zona de servicio de 50 millas de Tampa',
      next: 'Continuar',
      back: 'Atrás',
      reviewOrder: 'Revisar Orden',
      orderSummary: 'Resumen de la Orden',
      fromLabel: 'Desde',
      toLabel: 'Hasta',
      dateLabel: 'Fecha de Mudanza',
      allIncluded: 'Camión, equipo, mantas, cajas, diesel — todo incluido.',
      emailNotice: 'Al confirmar, los detalles de tu orden serán enviados a nuestro equipo y recibirás un correo de confirmación.',
      confirmAndPay: 'RESCATAR MI HOGAR',
      redirectingTitle: 'REDIRIGIENDO AL PAGO SEGURO...',
      redirectingMessage: 'Tus datos de mudanza han sido guardados. Llevándote a completar tu pago ahora.',
      orderRef: 'Referencia de Orden',
      close: 'Volver al Inicio'
    },
    faq: {
      title: 'PREGUNTAS FRECUENTES',
      questions: [{
        q: '¿Por qué el precio es tan bajo comparado con otros?',
        a: 'Porque eliminamos la oficina lujosa, los vendedores telefónicos y el desperdicio de tiempo. Somos una operación automatizada y eficiente que te pasa el ahorro directamente a ti.'
      }, {
        q: '¿Y si tengo escaleras o vivo en un 3er piso?',
        a: 'No nos importa. Otras empresas te castigan por vivir en un apartamento con escaleras. Nosotros somos "Fighters", estamos entrenados para eso. El precio es el mismo.'
      }, {
        q: '¿Qué pasa si el camión llega y hay más cajas de las que dije?',
        a: 'Nuestros paquetes están basados en el tamaño de la casa (Rooms). Si elegiste el paquete correcto para tu casa de 2 habitaciones, nosotros cargamos todo lo que corresponde a esa casa. Sin dramas.'
      }, {
        q: '¿Qué pasa si no tengo fecha exacta todavía?',
        a: "Puedes comprar tu paquete hoy para asegurar el precio congelado y enviarnos un ticket de 'Fecha Pendiente'. Una vez la tengas, nos avisas con al menos 72 horas de antelación para agendarte."
      }, {
        q: '¿Puedo cambiar la fecha después de comprar?',
        a: 'Sí, siempre que haya disponibilidad y nos avises con más de 72 horas de anticipación. No cobramos penalidad por el primer cambio.'
      }, {
        q: '¿Realmente incluyen el diesel y las escaleras?',
        a: 'SÍ. El concepto de Move Fighters es eliminar la letra pequeña. El precio que pagas en esta web es el TOTAL.'
      }]
    },
    footer: {
      tagline: 'Rescatando tu Hogar en Tampa.',
      licensed: 'Licenciados y Asegurados — Registro de Mudanceros FL Activo',
      help: '¿Necesitas ayuda inmediata?',
      callNow: 'Llamar Ahora',
      rights: 'Todos los derechos reservados.',
      services: {
        title: 'Nuestros Servicios',
        items: ['Mudanza Residencial', 'Mudanza de Apartamentos', 'Ensamblaje de Muebles', 'Protección de TV y Electrónicos', 'Empaque y Desempaque', 'Agenda en la Misma Semana']
      },
      company: {
        title: 'Compañía',
        items: ['Sobre Move Fighters', 'Nuestra Flota', 'Área de Cobertura', 'Carreras', 'Contáctanos']
      },
      legal: {
        title: 'Legal',
        terms: 'Términos de Servicio',
        privacy: 'Política de Privacidad',
        cancellation: 'Política de Cancelación',
        insurance: 'Seguro y Responsabilidad'
      },
      contact: {
        title: 'Contacto',
        phone: '(813) 476-8935',
        email: 'info@movefighters.com',
        hours: 'Lun–Sáb: 7:00 AM – 8:00 PM',
        hoursSun: 'Domingo: 8:00 AM – 5:00 PM',
        address: 'Tampa, FL — Servicio en radio de 50 millas'
      },
      newsletter: {
        title: 'Tips de Mudanza y Ofertas',
        placeholder: 'Ingresa tu email',
        button: 'Suscribirse',
        note: 'Sin spam. Cancela cuando quieras.'
      },
      badges: ['Precio Fijo', 'Sin Cargos Ocultos', 'Licenciados y Asegurados', 'Local de Tampa']
    }
  }
};
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [language, setLanguage] = useState<Language>('en');
  const value = {
    language,
    setLanguage,
    t: translations[language]
  };
  return <LanguageContext.Provider value={value} data-id="element-567">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};